import React, { useContext, useEffect, useState } from 'react';
import useTitle from '../../hooks/useTitle';
import { AuthContext } from '../AuthProvider/AuthProvider';
import Loader from '../Loader/Loader';
import ReviewTable from './ReviewTable';

const Myreviews = () => {
    //update title
    useTitle("my_review")

    const { user, logOut } = useContext(AuthContext)
    const [loader, setLoader] = useState(true)
    const [reviews, setReviews] = useState(null)
    const [dependency, setDependency] = useState(false)


    useEffect(() => {
        fetch(`https://review-server-rdm-jony.vercel.app/my-review?email=${user?.email}`, {
            headers: {
                auhtorization: `Bearer ${localStorage.getItem("review-token")}`
            }
        })
            .then(res => res.json())
            .then(data => {
                setReviews(data)
                setLoader(false)
            })
            .catch(er => console.log(er))
    }, [dependency, user, logOut, setLoader])

    if (loader) {
        return <Loader></Loader>
    }
    console.log(reviews)
    return (
        <div className='md:mx-20 mx-5 my-10'>

            {
                reviews ?
                    <div>
                        <h3 className='font-semibold text-warning text-3xl text-center my-10'>MyReviews & Ratings</h3>
                        <div className="overflow-x-auto w-full">
                            <table className="table w-full  mx-auto">

                                <thead className="hidden md:table-header-group">
                                    <tr>
                                        <th>Name</th>
                                        <th>service</th>
                                        <th>Rating</th>
                                        <th>update</th>
                                        <th>Delete</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        reviews?.map(review => <ReviewTable key={review._id} review={review} dependency={dependency} setDependency={setDependency}></ReviewTable>)
                                    }

                                </tbody>
                                {/* <!-- foot --> */}
                            </table>
                        </div>
                    </div>
                    :
                    <div className='flex justify-center items-center w-screen h-screen'>
                        <p className='font-semibold text-2xl text-warning'>No reviews were added</p>
                    </div>
            }
        </div>
    );
};

export default Myreviews;